import React, { useCallback } from "react";
import { Flex, Text } from "@jsq/ds/core";
import { Icon } from "@jsq/ds/icons";
import { Sizes } from "@jsq/ds/styles";
import * as styles from "./styles_vanilla.css";
import { ConfigurationTool } from "./types";

export type ToolCardProps = {
  tool: ConfigurationTool;
  onClick: (path: string) => void;
};

export const ToolCard: React.FC<ToolCardProps> = ({ tool, onClick }) => {
  const handleClick = useCallback(() => {
    if (tool.path) {
      onClick(tool.path);
    }
  }, [tool.path, onClick]);

  return (
    <button onClick={handleClick} className={styles.toolCard} disabled={!tool.path}>
      <Flex gap={12} alignItems="center">
        <Icon type={tool.iconType} size="medium" className={styles.toolIcon} />
        <Flex flexDirection="column" gap={Sizes.XS} alignItems="flex-start">
          <Text variant="strong-md">{tool.title}</Text>
          {tool.description && (
            <Text variant="regular-sm" className={styles.toolDescription}>
              {tool.description}
            </Text>
          )}
        </Flex>
      </Flex>
    </button>
  );
};
